import React from 'react';
import VideoVisitTerms from "./VideoVisitTerms";
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";


function replaceH1WithH2(textContent,domParent){
    const xpath = `//h1[text()='${textContent}']`;
    const element = document.evaluate(xpath, domParent, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    if (element) element.outerHTML = '<h2>' + element.innerHTML + '</h2>';
}

class AgreeToTerms extends React.Component {
    constructor() {
        super();
        this.state = {
            acknowledgeReceipt: false,
            acknowledgeAccessMyRecords: false,
            acknowledgeTexasState: false,
            acknowledgeReceiveTreatment: false,
            showModal: false,
            heading: "",
            isTermsSelectionError: false
        };
    }

    componentDidMount() {
        this.props.getVideoVisitTerms();
        logUI("MBHWeb.UI.VideoVisit.AgreeToTerms.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    
    onDocsSelectionChange = (e, legalDocType) => {
        if (e.target) {
            this.setState({
                [legalDocType]: e.target.checked ? true : false
            }, () => {
                const { acknowledgeAccessMyRecords, acknowledgeReceipt, acknowledgeReceiveTreatment, acknowledgeTexasState, isTermsSelectionError } = this.state;
                const { enableVirtualDashboardUpdates } = this.props;
                const isAcknowledged = !enableVirtualDashboardUpdates ? acknowledgeAccessMyRecords && acknowledgeReceipt && acknowledgeTexasState && acknowledgeReceiveTreatment
                    : acknowledgeAccessMyRecords && acknowledgeReceipt && acknowledgeTexasState;
                if (isAcknowledged) {
                    if (isTermsSelectionError) {
                        this.setState({
                            isTermsSelectionError: false
                        });
                    }
                }
            });
        }
        logUI("MBHWeb.UI.VideoVisit.AgreeToTerms.DocSelection", new Date(), Tools.getURLPath());
    }
    isValid() {
        return true;
    }
    toggleModal = (showModal, heading) => {
        this.setState({ showModal: showModal, heading: heading });
    }
    acceptTerms() {
        const { acknowledgeAccessMyRecords, acknowledgeReceipt, acknowledgeTexasState, acknowledgeReceiveTreatment, isTermsSelectionError } = this.state;
        const { enableVirtualDashboardUpdates } = this.props;
        const isAcknowledged = !enableVirtualDashboardUpdates ? acknowledgeAccessMyRecords && acknowledgeReceipt && acknowledgeTexasState && acknowledgeReceiveTreatment
            : acknowledgeAccessMyRecords && acknowledgeReceipt && acknowledgeTexasState;
        if (isAcknowledged) {
            const { acceptTerms, goNext, videoVisitTerms: { terms } = {} } = this.props;
            acceptTerms(terms.versionId);
            goNext();
        }
        else {
            if (!isTermsSelectionError) {
                this.setState({
                    isTermsSelectionError: true
                });
            }
        }
    }
    render() {
        const { acknowledgeReceipt, acknowledgeAccessMyRecords, acknowledgeTexasState, acknowledgeReceiveTreatment, showModal, heading, isTermsSelectionError } = this.state;
        const { videoVisitTerms, technicalHelpDeskNumber, technicalHelpDeskHours, enableVirtualDashboardUpdates } = this.props;
        const termsToDisplay = videoVisitTerms && videoVisitTerms.terms && videoVisitTerms.terms.textToDisplay ? videoVisitTerms.terms.textToDisplay : "";

        if (termsToDisplay && !this.terms) {
            if (window && window.DOMParser) {
                const parser = new DOMParser();
                try {
                    const parseFromString = parser.parseFromString(termsToDisplay, 'text/html');
                    if (parseFromString && parseFromString.body) {
                        // replace H1 present in termsToDisplay to H2 as staticHtmlContent does not allow H1 tags.                        
                        replaceH1WithH2('NOTICE CONCERNING COMPLAINTS', parseFromString.body);
                        replaceH1WithH2('PATIENT RIGHTS AND RESPONSIBILITIES', parseFromString.body);                        
                        this.terms = parseFromString.body.innerHTML;                        
                    }
                } catch (err) {
                    this.terms = termsToDisplay;
                }
            }
            
        }
       
        return (
            <div className="agree-to-terms-container sm-width-step" style={this.props.style}>
                <div className="row">
                    <div className="col-12">
                        <h1 className="step-heading step-heading-md">The legal docs</h1>
                    </div>
                    <div className="col-12 step-form-container">
                        <div className="row legal-docs-container">
                            <div className="col-12">
                                <label className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        name="acknowledgeReceipt"
                                        checked={acknowledgeReceipt}
                                        onChange={(e) => this.onDocsSelectionChange(e, "acknowledgeReceipt")}
                                    />
                                    <span className="checkmark" />
                                    <span className="checkbox-label">I acknowledge receipt of the <span className="doc-highlighter">
                                        {this.terms && this.terms !== "" ? <a href="#" onClick={(e) => { e.preventDefault(); this.toggleModal(true, "Patients' Rights");}}>
                                            Patients' Rights</a> : "Patients' Rights"}
                                        {this.terms && this.terms !== "" ? <a href="#" onClick={(e) => { e.preventDefault(); this.toggleModal(true, "Complaint Notice and Privacy Practice");}}>
                                           , Complaint Notice and Privacy Practice </a> : ", Complaint Notice and Privacy Practice"}
                                    </span> forms.</span>
                                </label>
                            </div>
                            {!enableVirtualDashboardUpdates &&
                                <div className="col-12">
                                    <label className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            name="acknowledgeReceiveTreatment"
                                            checked={acknowledgeReceiveTreatment}
                                            onChange={(e) => this.onDocsSelectionChange(e, "acknowledgeReceiveTreatment")}
                                        />
                                        <span className="checkmark" />
                                        <span className="checkbox-label">By continuing, I give my consent to receive treatment and confirm that I am electronically signing the <span className="doc-highlighter">
                                            {this.terms && this.terms !== "" ? <a href="#" onClick={(e) => { e.preventDefault(); this.toggleModal(true, "General Consent To Treat and Telemedicine Disclosure and Consent") }}>
                                                General Consent To Treat and Telemedicine Disclosure and Consent.</a> : "General Consent To Treat and Telemedicine Disclosure and Consent."}
                                        </span></span>
                                    </label>
                                </div>
                            }
                           
                            <div className="col-12">
                                <label className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        name="acknowledgeAccessMyRecords"
                                        checked={acknowledgeAccessMyRecords}
                                        onChange={(e) => this.onDocsSelectionChange(e, "acknowledgeAccessMyRecords")}
                                    />
                                    <span className="checkmark" />   
                                    {enableVirtualDashboardUpdates ?
                                        <span className="checkbox-label">I acknowledge that I can access records of my care at any time through my MyBSWHealth account and, with my consent, a summary of the visit I am about to have will be sent to my primary care provider.  You may confirm that you consent to have this visit summary sent to your primary care provider by calling the MyBSWHealth Technical Help Desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.</span>
                                        :
                                        <span className="checkbox-label">I acknowledge that I can access my visit records at any time through my MyBSWHealth account and my after visit summary will not automatically be sent to my primary care provider.</span>
                                    }                                    
                                </label>
                            </div>

                            <div className="col-12">
                                <label className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        name="acknowledgeTexasState"
                                        checked={acknowledgeTexasState}
                                        onChange={(e) => this.onDocsSelectionChange(e, "acknowledgeTexasState")}
                                    />
                                    <span className="checkmark" />
                                    <span className="checkbox-label">I confirm I will be located in the State of Texas during my appointment.</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="footer-buttons">
                            {isTermsSelectionError &&
                                <div className="error-msg">Please agree to terms.</div>
                            }
                            <button className={`btn btn-primary`}
                                onClick={() => this.acceptTerms()}>
                                    AGREE
                            </button>
                        </div>
                    </div>
                </div>
                {showModal === true && <VideoVisitTerms heading={heading} showModal={showModal} toggleModal={this.toggleModal} terms={this.terms}/>}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        videoVisitTerms: state.videoVisitScheduling.videoVisitTerms ? state.videoVisitScheduling.videoVisitTerms : {},
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours:"",
        enableVirtualDashboardUpdates: state.session.serverData && state.session.serverData.enableVirtualDashboardUpdates
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getVideoVisitTerms: () => dispatch({ type: types.GET_VIDEO_VISIT_TERMS })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(AgreeToTerms);